import React, { useEffect, useState } from 'react';
import FormField from '../../common/form-field';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import css from './label.module.css';
import { useFormContext, useWatch } from 'react-hook-form';

export default function Label(name: string, label?: string): FormComponent {
  return ({ ...rest }) => (
    <LabelComponent label={label} name={name} {...rest} />
  );
}

export function LabelComponent({
  name,
  label,
  parentName,
}: FormComponentProps & {
  name: string;
  label?: string;
}) {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const inputName = parentName ? `${parentName}.${name}` : name;
  const [val, setVal] = useState('');

  const inputWatch = useWatch({ name: inputName });

  useEffect(() => {
    if (inputWatch !== undefined) {
      setVal(inputWatch);
    }
  }, [inputWatch, setVal]);

  return (
    <FormField label={label ? t(label) : t(inputName)} labelFor={inputName}>
      <label className={css['label']}>{val}</label>
      <input {...register(name)} type="hidden" name={inputName} />
    </FormField>
  );
}
